{
  "secretary": {
    "navLabel": "Secrétaire intelligent",
    "title": "Secrétaire intelligent {{brand}}",
    "recorder": {
      "record": "Dites une commande — p. ex. « rendez-vous pour Rezaei demain à dix heures »",
      "recording": "J’écoute…",
      "stop": "Arrêter et exécuter",
      "discard": "Abandonner",
      "processing": "Le secrétaire travaille…",
      "warn": {
        "nothing": "Je n’ai rien entendu",
        "busy": "Le secrétaire traite encore la commande précédente",
        "mic": {
          "denied": "L’accès au micro n’a pas été autorisé",
          "unsupported": "Ce navigateur ne peut pas enregistrer le son",
          "error": "Le micro ne s’est pas ouvert"
        }
      }
    },
    "notice": {
      "listLabel": "Résultats du secrétaire intelligent",
      "heard": "Entendu : « {{text}} »",
      "dismiss": "Fermer",
      "more": "{{count}} de plus",
      "open": "Ouvrir",
      "bookReady": "Le rendez-vous de {{name}} est prêt",
      "followUpReady": "Le suivi de {{name}} est prêt",
      "slotLine": "{{day}}, {{time}}",
      "slotLineClinic": "{{day}}, {{time}} — {{clinic}}",
      "noSlot": "Aucun créneau libre trouvé",
      "choosePatient": "Quel « {{name}} » ?",
      "candidates": "{{count}} patients portent ce nom",
      "notFound": "« {{name}} » ne figure pas parmi vos patients",
      "openRecord": "Dossier de {{name}}",
      "daySummary": "Vous avez {{total}} rendez-vous aujourd’hui",
      "noClinic": "Vous n’avez pas de clinique où réserver",
      "outOfScope": "Le secrétaire ne fait pas cela",
      "unavailable": "Le planning du jour n’a pas pu être lu",
      "unknown": "Je n’ai pas compris",
      "failed": "Le secrétaire n’a pas pu le faire",
      "noCredit": "{{coin}} insuffisants"
    },
    "window": {
      "close": "Fermer",
      "recordAgain": "Redites-le",
      "heard": "Entendu",
      "openForm": "Ouvrir le formulaire de rendez-vous",
      "pickSlot": "Choisissez l’un de ces créneaux ; le formulaire s’ouvre prérempli avec lui.",
      "hourTaken": "{{time}} est pris ; les créneaux libres les plus proches :",
      "hourFree": "{{time}} est libre.",
      "slot": "{{day}}, {{time}}",
      "requestOnly": "Cette clinique a fermé la réservation directe ; le rendez-vous est envoyé comme demande à confirmer par l’accueil.",
      "noSlotLine": "Aucun créneau libre n’a été trouvé pour {{name}} sur cette période. Vous pouvez ouvrir le formulaire et choisir un autre jour.",
      "choosePatientLine": "Plusieurs de vos patients ont un nom proche de « {{name}} ». Lequel ?",
      "newPatient": "Nouveau patient",
      "file": "Dossier {{file}}",
      "age": "{{age}} ans",
      "phoneTail": "Mobile …{{tail}}",
      "notFoundLine": "Aucun patient nommé « {{name}} » parmi les patients de vos cliniques.",
      "closest": "Noms les plus proches :",
      "noClinicTitle": "Vous n’avez pas encore de clinique",
      "noClinicLine": "Pour réserver des rendez-vous, vous devez être membre d’une clinique ou créer votre cabinet. Le secrétaire peut toujours ouvrir des dossiers et vous dire le planning du jour.",
      "readOnlyTitle": "Les abonnements de vos cliniques ont expiré",
      "readOnlyLine": "Rien ne peut être réservé dans une clinique tant qu’elle n’a pas renouvelé son abonnement.",
      "goReception": "Aller à l’accueil",
      "dayTitle": "Vous avez {{total}} rendez-vous aujourd’hui",
      "dayCounts": "{{completed}} terminés · {{arrived}} présents · {{scheduled}} en attente",
      "dayRequested": "{{count}} demandes en attente de la clinique",
      "dayNext": "À venir :",
      "dayNone": "Plus rien à venir aujourd’hui.",
      "noHour": "Sans rendez-vous",
      "unknownPatient": "Patient",
      "status": {
        "scheduled": "En attente",
        "requested": "En attente de la clinique",
        "arrived": "Présent",
        "in_visit": "En consultation"
      },
      "outOfScopeTitle": "Le secrétaire ne fait pas cela",
      "topic": {
        "clinical_record": "Rédigez ordonnances, diagnostics et notes dans la consultation elle-même.",
        "visit_flow": "Les consultations se démarrent et se terminent depuis l’accueil et la consultation.",
        "mark_arrived": "Enregistrer l’arrivée d’un patient revient à l’accueil de la clinique.",
        "reschedule_or_cancel": "Pour déplacer ou annuler un rendez-vous, ouvrez-le dans l’accueil.",
        "money": "Les questions d’argent sont dans la Comptabilité.",
        "send_message": "Envoyez les messages aux patients depuis Messages.",
        "delete_record": "Le secrétaire ne supprime jamais rien.",
        "other": "Le secrétaire prépare rendez-vous et suivis, ouvre les dossiers et donne le planning du jour."
      },
      "unavailableLine": "Le planning du jour n’a pas pu être lu pour l’instant. Redemandez dans un moment.",
      "unknownLine": "Le secrétaire peut préparer un rendez-vous ou un suivi, ouvrir un dossier et donner le planning du jour.",
      "failedLine": "Redites-le. Si cela se répète, faites-le depuis sa page.",
      "noCreditLine": "Rechargez vos {{coin}} pour utiliser le secrétaire.",
      "topUp": "Recharger des {{coin}}",
      "charged": "Des {{coin}} ont été déduits pour cette commande.",
      "notCharged": "Aucun {{coin}} n’a été déduit pour cette commande."
    },
    "form": {
      "notice": "Le secrétaire intelligent a rempli ce formulaire à partir de vos paroles ; vérifiez-le avant de réserver.",
      "reception_clinic": "Clinique : celle sélectionnée dans l’accueil.",
      "working_hours": "La clinique a été choisie d’après vos horaires.",
      "earliest_free": "La clinique avec le premier créneau libre a été choisie.",
      "newPatient": "Nouveau patient : son dossier est créé à la réservation.",
      "heardPhone": "Numéro entendu : {{phone}}",
      "booked": "Rendez-vous réservé.",
      "requested": "Demande de rendez-vous envoyée à la clinique pour confirmation."
    }
  }
}
